import crashlytics from '@react-native-firebase/crashlytics';

export class ErrorLogger {
  static logError(error: unknown, context?: string): void {
    if (__DEV__) {
      console.error(`[${context || 'Error'}]:`, error);
    }

    if (error instanceof Error) {
      crashlytics().recordError(error);
    } else if (typeof error === 'string') {
      crashlytics().log(error);
      crashlytics().recordError(new Error(error));
    } else {
      // Fallback for unexpected types
      const errorMessage =
        typeof error === 'object' && error !== null
          ? JSON.stringify(error)
          : String(error);
      crashlytics().log(`Unknown error type: ${errorMessage}`);
      crashlytics().recordError(new Error(errorMessage));
    }
  }

  static log(message: string, level: 'info' | 'warn' | 'error' = 'info'): void {
    if (__DEV__) {
      console.log(`[${level.toUpperCase()}]:`, message);
    }

    crashlytics().log(`[${level.toUpperCase()}]: ${message}`);
  }

  static setUserId(userId: string): void {
    crashlytics().setUserId(userId);
  }

  static setAttribute(key: string, value: string): void {
    crashlytics().setAttribute(key, value);
  }

  static setAttributes(attributes: { [key: string]: string }): void {
    crashlytics().setAttributes(attributes);
  }
}
